import * as T from '../types';
import { PaymentGate } from '../types';

const setCurrentPaymentGate = (gate: PaymentGate) => {
  return { type: T.SET_CURRENT_PAYMENT_GATE, gate };
};

export default setCurrentPaymentGate;
